import { Component, ojs, app, state, v, component } from "modular-openscriptjs";
import {
    pageInfo,
    scrollToTop,
    empty,
    tab,
    eParse,
    either,
} from "../../../helpers";
import { dom } from "../../../fotastart";
import { api, PAGES } from "../../../declarations";
import { routes } from "../../../backendRoutes";

// Components
import ViewProduct from "../../Views/ViewProduct";
import Fab from "../../Blocks/Fab";

const h = app("h");
const route = app("router");
const $e = app("$e");

ojs(ViewProduct, Fab);

export default class SingleProduct extends Component {
    product = state(null);

    render(...args) {
        pageInfo(PAGES.VIEW_PRODUCT);
        scrollToTop();

        if (this.product == null) this.product = state(null);

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },

            h.div(
                { class: "container" },

                // Header
                h.div(
                    {
                        class: "d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm rounded-circle p-2",
                                onclick: "history.back()",
                                title: "Go Back",
                            },
                            h.i({
                                class: "bi bi-arrow-left fs-5",
                                style: "display: block; width: 24px; height: 24px; line-height: 24px;",
                            }),
                        ),
                        h.h2({ class: "fw-bold mb-0" }, PAGES.VIEW_PRODUCT),
                    ),
                    v(this.product, (product) => {
                        if (empty(product.value)) return null;

                        return h.button(
                            {
                                class: "btn btn-primary rounded-pill px-4 py-2 fw-bold shadow-sm",
                                listeners: {
                                    click: () =>
                                        route.to("business.products.edit", {
                                            companyId: window.currentCompany.id,
                                            productId: this.product.value.id,
                                        }),
                                },
                            },
                            h.i({ class: "bi bi-pencil-square me-2" }),
                            "Edit Product",
                        );
                    }),
                ),

                h.div(
                    { class: "mb-3" },
                    v(this.product, (product) => {
                        if (empty(product.value)) return null;

                        return h.ViewProduct(this.product, {
                            class: "p-0",
                        });
                    }),
                ),

                // Floating Action Buttons
                h.Fab([
                    h.button(
                        {
                            class: "btn btn-dark shadow-lg rounded-circle d-flex align-items-center justify-content-center",
                            style: "width: 50px; height: 50px;",
                            listeners: {
                                click: () =>
                                    route.to("business.products.edit", {
                                        companyId: window.currentCompany.id,
                                        productId: this.product.value.id,
                                    }),
                            },
                        },
                        h.i({ class: "bi bi-pencil-square" }),
                    ),
                ]),
                ...args,
            ),
        );
    }

    async $_mounted(componentId) {
        let c = component(componentId);

        if (c) {
            c.getProduct(route.params.productId);
        }
    }

    async getProduct(productId) {
        let res = await api.get(`${routes.products}/${productId}`);

        if (!res) {
            app("router").to("app.search");
            return;
        }

        this.product.value = res.data.product;
        pageInfo(`${PAGES.VIEW_PRODUCT} - ${res.data.product.name}`);
    }

    cleanUp() {
        super.cleanUp();
        this.product = null;
    }

    $$product = {
        stored: (ed, event) => this.updateProduct(ed, event),
    };

    updateProduct(ed, event) {
        if (!route.is("product.view-product")) return;

        const { message } = eParse(ed);
        const product = message.get("product");

        if (this.product.id !== product.id) return;
        this.product.value = product;
    }
}

ojs(SingleProduct);
